<template>
    <div>
        <h1 class="display-heading">Profile Verification</h1>

        <div class="d-flex align-items-baseline">
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Full Name:</label>
                <input style="width: 150px" type="text" name="filterName" data-vv-as="filter full name" data-vv-validate-on="blur"
                    v-model="filterName"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterName')
                    }">
                <div v-show="validationErrors.has('filterName')" class="invalid-feedback">
                    {{ validationErrors.first('filterName') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">NRIC:</label>
                <input style="width: 150px" type="text" name="filterIdentityNumber" data-vv-as="filter NRIC" data-vv-validate-on="blur"
                    mask="######-##-####" v-model="filterIdentityNumber"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterIdentityNumber')
                    }">
                <div v-show="validationErrors.has('filterIdentityNumber')" class="invalid-feedback">
                    {{ validationErrors.first('filterIdentityNumber') }}
                </div>
            </div>
            <button @click="getfamily" class="btn btn-primary">Search</button>
        </div>

        <div class="table-responsive">
            <div ref="tableSection">
                <table ref="listTable" class="table table-hover">
                    <col width="50">
                    <col>
                    <col width="200">
                    <col width="150">
                    <col width="150">
                    <col width="150">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Full Name</th>
                            <th scope="col">NRIC</th>
                            <th scope="col">OCR Status</th>
                            <th scope="col">Manual Verification</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="requestList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(data, index) in requestList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                            <td>{{data.name}}</td>
                            <td>{{data.nric}}</td>
                            <td>
                                <span :class="'badge badge-pill ' + getRequestStatusClass(data.ocrVerified)">
                                    {{getRequestStatus(data.ocrVerified)}}
                                </span>
                            </td>
                            <td>
                                <span :class="'badge badge-pill ' + getRequestStatusClass(data.manualVerified)">
                                    {{getRequestStatus(data.manualVerified)}}
                                </span>
                            </td>
                            <td>
                                <router-link :to="{
                                    'name': 'profile-verification-detail',
                                    'params': {'id': data.profileVerificationId}
                                }">
                                View request
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import pagination from '@/components/pagination';
import identificationTypes from '@/config/identificationTypes';
import {
    mask
} from 'vue-the-mask';
export default {
    'name': 'requestList',
    'directives': {
        mask
    },
    'components': {
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        },
        identificationTypeValidation () {
            let minIdentificationType = this.identificationTypes[0].value;
            let maxIdentificationType = this.identificationTypes[this.identificationTypes.length - 1].value;

            return `required|between:${minIdentificationType},${maxIdentificationType}`;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getfamily();
            });
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'filterName': '',
            'filterIdentityNumber': '',
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'requestList': [],
            identificationTypes
        };
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getfamily();
    },
    'methods': {
        getRequestStatus (s) {
            switch (s) {
            case 1:
                return 'Pending';
            case 2:
                return 'Approved';
            case 3:
                return 'Rejected';
            case 4:
                return 'Requested Resend';
            default:
                return 'Not Sent';
            }
        },
        getRequestStatusClass (s) {
            switch (s) {
            case 1:
                return 'badge-warning';
            case 2:
                return 'badge-success';
            case 3:
                return 'badge-danger';
            case 4:
                return 'badge-primary';
            default:
                return 'badge-secondary';
            }
        },
        getfamily () {
            this.axios.post('Kyc/GetFilteredList', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize,
                'fn': this.filterName,
                'in': this.filterIdentityNumber
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.requestList = list.map((data) => ({
                    'profileVerificationId': data.pvi,
                    'name': data.fn ? data.fn : '-',
                    'nric': data.in ? data.in : '-',
                    'ocrVerified': data.ov,
                    'manualVerified': data.mv,
                    'createAt': data.ca
                }));
            });
        }
    }
};

</script>

<style>

</style>
